import { Component } from '@angular/core';
import { NgxCarousel } from 'ngx-carousel';

import { Item } from '../../entities/item.entities'
import { Product } from '../../entities/product.entities'
import { ProductService } from '../../services/product.service'
import { CartService } from '../../services/cart.service'

@Component({
    selector: 'carousel-edit-dried',
    template: `
    <div class="row px-3">
                <div class="col-lg-12 col-md-12 col-12">
                    <div class="row">
                        <div class="col-lg-3 col-md-4 col-6 py-2 px-1" *ngFor="let Productitem of products | paginate: { itemsPerPage: 8, currentPage: page };let i = index; ">
                            <div class="card ho product-box mx-auto w-100">
                                <div class="card-header p-1"  [routerLink]="['Detail-Item',Productitem.id]"><img class="w-100" src="{{Productitem.photo}}" alt="First slide"/></div>
                                <div class="card-body px-1">
                                    <div class="col-lg-12 col-md-12 col-12 py-2 text-truncate" >{{Productitem.name}}</div>
                                    <div class="col-lg-12 col-md-12 col-12 text-left text-secondary" style="font-size: 0.8rem;" [routerLink]="['Detail-Item',Productitem.id]">รายละเอียดสินค้า</div>
                                    <div class="col-lg-12 col-md-12 col-12 text-left text-success text-right price-text">{{Productitem.price}} บาท</div>
                                    
                                    <div class="col-lg-12 col-md-12 col-12 px-0 py-2 p-3  " style="font-size: 0.7rem;">
                                        <div class="row">
                                            <div class="col-lg-12 col-md-12 col-12 text-secondary" style="font-size: 0.7rem;">
                                                <app-cart-modal [id]="Productitem.id"></app-cart-modal>
                                            </div> 
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
            <div class="col-lg-12 col-md-12 col-12">
              <div class="row">
                <div class="col-lg-12 col-md-12 col-12 pt-3">
                  <div class="has-text-centered" style="width:100%;text-align:center;">
                    <pagination-controls (pageChange)="page = $event"></pagination-controls>
                  </div>
                </div>
              </div>
            </div>
          </div>
  `,
    styles: [`
    .leftRs {
        position: absolute;
        margin: auto;
        top: 0;
        bottom: 0;
        width: 50px;
        height: 50px;
        box-shadow: 1px 2px 10px -1px rgba(0, 0, 0, .3);
        border-radius: 999px;
        left: 0;
        border: 0;
        background-color: rgba(0, 0, 0, 0.45);
        opacity:0;
        transition:all 0.5s;
    }
    .rightRs {
        position: absolute;
        margin: auto;
        top: 0;
        bottom: 0;
        width: 50px;
        height: 50px;
        box-shadow: 1px 2px 10px -1px rgba(0, 0, 0, .3);
        border-radius: 999px;
        right: 0;
        border: 0;
        background-color: rgba(0, 0, 0, 0.45);
        opacity:0;
        transition:all 0.5s;
    }
    li.active{
        background: rgba(27, 30, 33, 0.61);
    }
  `]
})
export class DriedComponent {

    /*
    
    */
    public carouselOne: NgxCarousel;
    // public showSelect: boolean;
    private items: number[] = [];
    private products: Product[] = [];

    private itemCart: Item[];
    private itemCarttmp: Item[];
    private loadQuantity: any;

    // เพิ่มสินค้า //
    private cardLocalArray = [];
    private showbutton: boolean = true;
    // private n ='0';
    page: number = 1;
    private carouseltab: any[] = [];
    rows:any[] = []
    private quantity: any;
    // private tab:string;
    constructor(private productService: ProductService, private cartService: CartService) {
        // localStorage.clear();
        //  Get Item service Product
        this.quantity = this.cartService.getCart()
        this.productService.getProduct().subscribe((snapshot) => {
            // Get item Sub item type 4 
            let index : number = 0;
            for (var i = 0; i < snapshot.length; i++) {
                if (snapshot[i].type == '3') {
                    this.products[index] = snapshot[i]
                    index++;
                }
            }
            this.rows = Array.from(Array(Math.ceil(this.products.length / 8)).keys())

            for (let n = 0; n < this.products.length / 8; n++) {
                ++this.carouseltab.length;
            }
            // if(this.products.length%8 != 0){
            //     ++this.carouseltab; 
            // }
        });
        this.carouselOne = {
            grid: { xs: 1, sm: 1, md: 1, lg: 1, all: 0 },
            slide: 1,
            speed: 400,
            interval: 4000,
            point: {
                visible: true
            },
            load: 2,
            touch: true,
            loop: false,
            custom: 'banner'
        }
    }

    hoverDivName;
    hideDiv = { opacity: '0' };
    showDiv = { opacity: '1' };

    show(divName: string) {
        this.hoverDivName = divName;
    }

    hide(divName: string) {
        this.hoverDivName = null;
    }
   

}



// WEBPACK FOOTER //
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/app/components/carousel/item-content-dried.ts